export enum OrderTransactionType {
  BOOKING = 'booking',
  INVOICE = 'invoice',
}